// svelte
import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
    _stats: {},
    _locales: "cs-CZ",
    _dev: true,
    _vtext: "",
    _vhtml: ""
	}
});

export default app;